import algoliasearch from 'algoliasearch'

const client = algoliasearch('testingYA3RG061BL', '3884ebb0619b13dcec74002f555c8990')
const profiles = client.initIndex('profiles')
const banners = client.initIndex('banners')

export default {
  profiles,
  banners,
}
